<template>
    <div v-if="listGroup.length > 0" class="list-group">

        <b-table ref="tableGroup" striped hover :fields="fieldsTableGroup" thead-class="hidden_header"
            :items="listGroup" class="table-list-group">
            <!-- <template #head(stt)="data">
                <span class="col-table col-table-stt">{{ data.label }}</span>
            </template>

<template #head(name)="data">
                <span class="col-table">
                    {{ data.label }}
                </span>
            </template> -->
            <template #cell(name)="data">
                <div class="col-name b-col-group" @click="toggleCollapseGroup(data.item)">
                    <img class="icon-groups" width="20" src="@/assets/img/icon_groups.png" />
                    <span>{{ data.item.name }}</span>
                </div>
                <b-collapse class="wrap-menu-collapse" :visible="data.item.isCollapse">
                    <div class="menu-collapse" @click="handleViewListMember(data.item)"
                        :class="currentMenuTab === data.item.id + 'tabMember' ? 'active' : ''">Danh
                        sách học sinh </div>
                    <div class="menu-collapse" @click="handleViewListDocument(data.item)"
                        :class="currentMenuTab === data.item.id + 'tabDocument' ? 'active' : ''">Danh
                        sách tài liệu</div>
                </b-collapse>
            </template>

            <template #cell(action)="row">
                <span @click="handleEditGroup(row)" class="mr-2 btn-edit">
                    Sửa
                </span>
                /
                <span @click="handleDeleteGroup(row)" class="mr-2 btn-delete">
                    Xóa
                </span>
            </template>
        </b-table>

        <ModalDeleteClassSchoolGroup v-if="isOpenModalDeleteClassSchoolGroup" @closeModal="closeModalDeleteGroup"
            :item="itemSelected" @handleDeleteDone="handleDeleteDone" />
    </div>
    <div v-else class="list-group">
        Lớp học không có nhóm
    </div>
</template>
<script>
import { getAllGroupClassSchoolService } from './../../_api/classSchoolGroupServices'

import ModalDeleteClassSchoolGroup from './../../_components/ModalDeleteClassSchoolGroup.vue'
export default {
    components: {
        ModalDeleteClassSchoolGroup
    },
    data() {
        return {
            classSchoolId: 0,
            fieldsTableGroup: [{ key: 'name', label: 'Tên nhóm' }, { key: 'action', label: 'Thao tác' }],
            listGroup: [],
            isOpenModalDeleteClassSchoolGroup: false,
            currentMenuTab: '',
        }
    },
    watch: {
        'listGroup': 'loadDefaultGroup',
    },
    mounted() {
        this.classSchoolId = this.$route.query.id
        //this.getAllGroupClassSchool()
    },
    methods: {
        toggleCollapseGroup(item) {

            item.isCollapse = !item.isCollapse
            this.$refs.tableGroup.refresh();
        },
        handleDeleteDone() {
            this.getAllGroupClassSchool()
            this.closeModalDeleteGroup()
        },
        closeModalDeleteGroup() {
            this.isOpenModalDeleteClassSchoolGroup = false
        },
        handleViewListMember(row) {
            this.currentMenuTab = row.id + 'tabMember'
            this.$emit('handleShowListMember', row.id, row.name)
        },
        handleViewListDocument(row) {
            this.currentMenuTab = row.id + 'tabDocument'
            this.$emit('handleShowListDocument', row.id, row.name)
        },
        handleEditGroup(row) {
            this.$emit('handleEditClassSchoolGroup', row.item.id)
        },
        handleDeleteGroup(row) {
            this.itemSelected = row.item
            this.isOpenModalDeleteClassSchoolGroup = true
        },
        getAllGroupClassSchool(paramQuery = {
            keyword: ''
        }) {
            let query = {
                classSchoolId: this.classSchoolId,
                keyword: paramQuery.keyword,
            }
            this.listGroup = []
            getAllGroupClassSchoolService(query).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listGroup.push({ 'id': item.id, 'stt': i + 1, 'name': item.name },)
                        if (i == 0) {
                            this.$emit('handleShowListMember', item.id, item.name)
                        }
                    }
                }
            })
            this.$emit('getListDataAllGroup', this.listGroup);
        },
        loadDefaultGroup() {
            if (this.listGroup.length > 0) {
                this.toggleCollapseGroup(this.listGroup[0]);
                this.handleViewListMember(this.listGroup[0]);
            }
        }
    }
}
</script>
<style>
.table-list-group tbody {
    display: block;
    height: 20rem;
    overflow: auto;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* even columns width , fix width of table too*/
}

thead {
    width: calc(100% - 1em)
        /* scrollbar is average 1em/16px width, remove it from thead width */
}

.custom-text-dropdown {
    color: black;
    background: transparent;
    outline: none;
    text-decoration: none;
}

.custom-text-dropdown:hover {
    color: black;
    background: transparent;
    outline: none;
    text-decoration: none;
}
</style>
<style lang="scss" scoped>
.wrap-menu-collapse {
    // border: 1px solid gray;
    // margin: 5px;
    // border-radius: 10px;
    border: none;
    width: max-content;
    margin-top: 10px;

    .menu-collapse {
        padding: 4px 20px;
        cursor: pointer;
    }

    .menu-collapse.active {
        //background-color: #bbe0fb;
        border-radius: 20px;
        //color: #007bff;
        font-weight: bold;

    }

    .menu-collapse:hover {
        //background: #e5e2e2;
        border-radius: 20px;
        font-weight: bold;
    }
}

.col-name {
    cursor: pointer;
}

.custom-text-dropdown {
    color: black;
    background: transparent;
    outline: none;
}

.btn-edit {
    color: #8ba3f9;
    cursor: pointer;
}

.btn-delete {
    color: red;
    cursor: pointer;
}

.col-table {
    font-size: 14px;
}

.text-btn-add-member {
    font-size: 12px;
    color: #4eec43;
}

.b-col-group {
    display: flex;
    align-items: center;
    column-gap: 0.6rem;
    border-bottom: 1px solid #ced4da;
    padding-bottom: 1rem;
}
</style>